<template>
  <va-card stripe="primary">
    <SwappingSquaresSpinner v-if="loadingHandle"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <div class="va-card__body" v-if="!loadingHandle">
      <form style="margin-top: 20px;">
        <div class="row">
          <va-input
            v-model="appSubscription.name"
            type="text"
            :label="$t('subscriptions.name')"
            class="flex xs12"
            :error="!!subscriptionNameErrors.length"
            :error-messages="subscriptionNameErrors"
          />

          <va-input
            v-model="appSubscription.description"
            type="text"
            :label="$t('subscriptions.description')"
            class="flex xs12"
          />

          <va-input
            v-model="appSubscription.appSubscriptionPrices[0].price"
            placeholder="Set price"
            type="number"
            :label="$t('subscriptions.setFixedPrice')"
            class="flex xs12"
            :error="!!subscriptionFixPriceErrors.length"
            :error-messages="subscriptionFixPriceErrors"
          />
        </div>
        <div class="row">
          <div class="flex xs12">
            <va-select
              :disabled="!paymentMethods.length > 0"
              :label="$t('subscriptions.paymentMethods')"
              :placeholder="paymentMethods.length < 1 ? $t('subscriptions.noPayment') : $t('subscriptions.multiplePayment')"
              v-model="appSubscription.appPaymentMethodTypes"
              multiple
              searchable
              textBy="type"
              keyBy="paymentMethodTypeId"
              :options="paymentMethods"
              :error="!!paymentMethodErrors.length"
            />
          </div>
        </div>
        <div class="row" style="padding-left: 10px; margin-bottom: 10px;">
          <fieldset class="xs12">
            <va-checkbox
              :label="$t('subscriptions.defaultSubscription')"
              v-model="appSubscription.isDefault"
            />
          </fieldset>
          <fieldset class="xs12" style="width: 100%;">
            <va-checkbox
              :label="$t('subscriptions.showThisPayment')"
              v-model="appSubscription.isUserShow"
            />
          </fieldset>
          <fieldset class="xs12" style="width: 100%;">
            <va-checkbox
              :label="$t('subscriptions.showThisPlan')"
              v-model="appSubscription.isGlobal"
            />
          </fieldset>
        </div>
        <div class="row">
          <div class="flex xs12">
            <va-select
              :disabled="locations.length < 1 || appSubscription.isGlobal"
              :label="appSubscription.isGlobal ? $t('subscriptions.selectLocations') : $t('subscriptions.selectLocationsRequired')"
              v-model="selectedLocations"
              :placeholder="locations.length < 1 ? $t('subscriptions.noLocation') : $t('subscriptions.multipleLocationSelect')"
              multiple
              searchable
              textBy="name"
              keyBy="eventId"
              :options="locations"
              :error="!!locationErrors.length"
            />
          </div>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button @click.prevent="onsubmit()" class="my-0">{{ $t('subscriptions.create') }}</va-button>
        </div>
      </form>
    </div>
  </va-card>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  name: 'FixAppSubscription',
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  data () {
    return {
      appSubscription: {
        name: '',
        description: '',
        appSubscriptionTypeId: undefined,
        isWithoutPrice: false,
        isGlobal: false,
        isDefault: false,
        isUserShow: false,
        isPeriod: false,
        isPerUnit: false,
        isFixPrice: true,
        isRequestTip: false,
        removedPrices: [],
        appSubscriptionPrices: [
          {
            subscriptionPriceMeta: [],
            period: 0,
            isOngoing: true,
            price: 0,
            order: 0,
          },
        ],
        eventIds: [],
        overwriters: [],
        appPaymentMethodTypes: [],
      },
      locations: [],
      paymentMethods: [],
      selectedLocations: [],
      subscriptionNameErrors: [],
      subscriptionFixPriceErrors: [],
      paymentMethodErrors: [],
      locationErrors: [],
      loadingHandle: true,
    }
  },
  methods: {
    parseSubscription () {
      const subscription = {
        name: this.appSubscription.name,
        description: this.appSubscription.description,
        isWithoutPrice: this.appSubscription.isWithoutPrice,
        isGlobal: this.appSubscription.isGlobal,
        isDefault: this.appSubscription.isDefault,
        isUserShow: this.appSubscription.isUserShow,
        isPeriod: this.appSubscription.isPeriod,
        isPerUnit: this.appSubscription.isPerUnit,
        isFixPrice: this.appSubscription.isFixPrice,
        isTipRequest: this.appSubscription.isRequestTip,
        appSubscriptionPrices: [],
        appSubscriptionTypeId: 5,
        eventIds: [],
        overwriters: [],
        appPaymentMethodTypes: [],
      }

      const subscriptionPaths = []

      this.appSubscription.appSubscriptionPrices.forEach((item, index) => {
        const metas = []
        subscriptionPaths.push({
          subscriptionPriceMeta: metas,
          period: Number.parseFloat(item.period),
          isOngoing: false,
          price: item.price ? Number.parseFloat(item.price) : 0.00,
          order: index,
        })
      })

      subscription.appSubscriptionPrices = subscriptionPaths

      // payment methods
      this.appSubscription.appPaymentMethodTypes.forEach(item => {
        subscription.appPaymentMethodTypes.push({
          appPaymentMethodTypeId: item.paymentMethodTypeId,
          description: item.description,
        })
      })

      // locations
      this.selectedLocations.forEach(item => {
        subscription.eventIds.push(item.eventId)
      })
      return subscription
    },
    async onsubmit () {
      this.modalLoader = true
      this.subscriptionNameErrors = this.appSubscription.name ? [] : [this.$t('subscriptions.subscriptionNameError')]
      this.paymentMethodErrors = this.appSubscription.appPaymentMethodTypes ? [] : [this.$t('subscriptions.paymentMethodError')]
      this.subscriptionFixPriceErrors = this.appSubscription.appSubscriptionPrices[0].price ? [] : [this.$t('subscriptions.fixPriceError')]
      if (!this.appSubscription.isGlobal) {
        this.locationErrors = this.selectedLocations.length ? [] : [this.$t('subscriptions.locationError')]
      }
      if (!this.formSubscriptionReady) {
        return
      }
      const subscriptions = this.parseSubscription()
      if (!subscriptions) {
        return
      }
      this.$store.dispatch('createAppSubscription', subscriptions).then(() => {
        this.$router.push({
          name: 'app-subscriptions',
        })
      })
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    async getTheLocations () {
      await this.$store.dispatch('getLocations')
        .then(resp => this.initlocations())
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    async initlocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
    },
    async initAppSubscriptions () {
      await this.getTheLocations().then(() => this.getPaymentMethodTypes()).then(() => this.$emit('handle-loader', false))
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    async getPaymentMethodTypes () {
      await this.$store.dispatch('getPaymentMethods')
        .then(resp => this.initPaymentMethodTypes(resp.data.message))
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    async initPaymentMethodTypes (paymentMethods) {
      this.paymentMethods.splice(0, this.paymentMethods.length, ...paymentMethods)
      this.loadingHandle = false
    },
  },
  computed: {
    formSubscriptionReady () {
      return !(this.subscriptionNameErrors.length || this.subscriptionFixPriceErrors.length || this.locationErrors.length || this.paymentMethodErrors.length)
    },
  },
  mounted () {
    this.initAppSubscriptions()
      .catch(error => {
        this.errorHandler(error.response)
        this.loadingHandle = false
      })
  },
}
</script>

<style scoped>

</style>
